import { render, staticRenderFns } from "./OrgaoForm.vue?vue&type=template&id=3f4f3d9b&scoped=true&"
import script from "./OrgaoForm.vue?vue&type=script&lang=js&"
export * from "./OrgaoForm.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./OrgaoForm.vue?vue&type=style&index=1&id=3f4f3d9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4f3d9b",
  null
  
)

export default component.exports